import moment from "moment";
import { useReducer } from "react";
import StoreContext, { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import {
  ICopyStoreProducts,
  ICreateStore,
  IUpdateStore,
} from "../../models/store/request";
import { IStore } from "../../models/store/response";
import { IStoreQuery } from "../../models/store/query";
import { ICreatePrize } from "../../models/prize/request";
export interface IProps {
  children: React.ReactNode;
}
const PrizeContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.prize.getAllPrize(state.query);

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });

        const { data } = await EndPoints.prize.getPrizet(id);
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = async (data?: IStore) => {
    // dispatch({ type: 'SET_DETAILSS', payload: { details: data } })
  };

  const createPrize = async (request: ICreatePrize) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.prize.createPrizet(request);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  
  const deletePrize = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.prize.deletePrize(id);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: IStoreQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };
 

  return (
    <StoreContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,

          createPrize,
          deletePrize,

          setSearch,
          setQuery,
        },
      }}
    >
      {props.children}
    </StoreContext.Provider>
  );
};

export default PrizeContextProvider;
